import {
  LifeSafer,
  Monitech,
  Guardian,
  QuickStart,
} from "../../_helpers/BrandConstants";

export const brandColors = {
  [LifeSafer]: {
    primary: "#1C355E",
    primaryLight: "#495d7e",
    primaryDark: "#132541",
    secondary: "#76BC21",
    tertiary: "#b4b4b4",
  },
  [Monitech]: {
    primary: "#E31837",
    primaryLight: "#b54556",
    primaryDark: "#be132d",
    secondary: "#153B55",
    tertiary: "#4b9CD3",
  },
  [Guardian]: {
    primary: "#B32017",
    primaryLight: "#993833",
    primaryDark: "#911812",
    secondary: "#232C39",
    tertiary: "#6C747D",
  },
  [QuickStart]: {
    primary: "#347ABF",
    primaryLight: "#84a1bd",
    primaryDark: "#2b66a1",
    secondary: "#1C3451",
    tertiary: "#1E4F88",
  },
};
